import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/Store';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <Suspense>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <App />
        <ToastContainer autoClose={2000} position="top-center" />
      </PersistGate>
    </Provider>
  </Suspense>
);